import { isPremiumUser, Pages, usePageData } from "@typeblind/pages-shared";
import { openConsentSettings, premiumEnabled } from "@typeblind/thirdparties";
import { Link as StaticLink } from "@typeblind/widget";
import { useIntl } from "react-intl";
import { Link as RouterLink } from "react-router";
import * as styles from "./SubMenu.module.less";

export function SubMenu({
  currentPath: _currentPath,
}: {
  readonly currentPath: string;
}) {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.root}>
      <MailLink />
      <RouterLink to={Pages.termsOfService.path}>
        {formatMessage(Pages.termsOfService.link.label)}
      </RouterLink>
      <RouterLink to={Pages.privacyPolicy.path}>
        {formatMessage(Pages.privacyPolicy.link.label)}
      </RouterLink>
      <CookieSettingsLink />
      <RemoveAdsLink />
    </div>
  );
}

function MailLink() {
  const { formatMessage } = useIntl();
  return (
    <StaticLink
      href="mailto:support@typeblind.com"
      target="email"
      title={formatMessage({
        id: "footer.emailLink.description",
        defaultMessage:
          "Send your comments and suggestions to support@typeblind.com",
      })}
    >
      support@typeblind.com
    </StaticLink>
  );
}

function CookieSettingsLink() {
  const { formatMessage } = useIntl();
  const { publicUser } = usePageData();
  return (
    isPremiumUser(publicUser) || (
      <button
        type="button"
        className={styles.linkButton}
        onClick={() => openConsentSettings()}
        title={formatMessage({
          id: "footer.cookieSettings.description",
          defaultMessage: "Review or change which cookies you allow.",
        })}
      >
        {formatMessage({
          id: "footer.cookieSettings.label",
          defaultMessage: "Cookie settings",
        })}
      </button>
    )
  );
}

function RemoveAdsLink() {
  const { formatMessage } = useIntl();
  const { publicUser } = usePageData();
  // Without a payment provider this offered to sell something the account page
  // no longer has on it — a link straight to a dead end.
  if (!premiumEnabled) {
    return null;
  }
  return (
    isPremiumUser(publicUser) || (
      <RouterLink
        to={Pages.account.path}
        title={formatMessage({
          id: "footer.removeAds.description",
          defaultMessage: "Purchase a premium account to remove ads.",
        })}
      >
        {formatMessage({
          id: "footer.removeAds.label",
          defaultMessage: "Remove Ads",
        })}
      </RouterLink>
    )
  );
}
